const jshmathsQuestions = [

{
  question: "Round 4,768,291 to the nearest million.",
  options: ["4,000,000", "5,000,000", "4,800,000", "4,700,000"],
  answer: "5,000,000"
},
{
  question: "Which of the following numbers is divisible by both 3 and 5?",
  options: ["45", "35", "25", "30"],
  answer: "45"
},
{
  question: "Express 0.00456 in standard form.",
  options: ["4.56 x 10^-3", "4.56 x 10^-2", "0.456 x 10^-2", "45.6 x 10^-4"],
  answer: "4.56 x 10^-3"
},
{
  question: "What is the value of 3^3?",
  options: ["3", "9", "6", "27"],
  answer: "27"
},
{
  question: "Simplify: 5/6 + 1/3",
  options: ["7/6", "1", "5/9", "2/3"],
  answer: "7/6"
},
{
  question: "A number is increased by 25% to become 100. What was the original number?",
  options: ["80", "75", "85", "90"],
  answer: "80"
},
{
  question: "Find the HCF of 36 and 54.",
  options: ["6", "9", "12", "18"],
  answer: "18"
},
{
  question: "Solve: 3x + 7 = 25",
  options: ["6", "5", "7", "8"],
  answer: "6"
},
{
  question: "What is the area of a circle with radius 7 cm? (pi = 22/7)",
  options: ["154 cm^2", "49 cm^2", "44 cm^2", "100 cm^2"],
  answer: "154 cm^2"
},
{
  question: "What is the sum of the interior angles of a pentagon?",
  options: ["540 degrees", "360 degrees", "720 degrees", "180 degrees"],
  answer: "540 degrees"
},
{
  question: "A bag contains 3 red, 2 blue, and 5 green balls. What is the probability of picking a blue ball?",
  options: ["1/5", "2/10", "1/10", "2/5"],
  answer: "1/5"
},
{
  question: "Simplify: (2x)(3x^2)",
  options: ["6x^3", "5x^3", "6x^2", "3x^2"],
  answer: "6x^3"
},
{
  question: "If 4x = 3y, express x in terms of y.",
  options: ["x = 3y/4", "x = 4y/3", "x = y/4", "x = 3/4y"],
  answer: "x = 3y/4"
},
{
  question: "Convert 72 km/h to m/s.",
  options: ["20 m/s", "18 m/s", "22 m/s", "24 m/s"],
  answer: "20 m/s"
},
{
  question: "Which of the following is NOT a prime number?",
  options: ["21", "17", "19", "23"],
  answer: "21"
},
{
  question: "Find the next term: 2, 6, 12, 20, __",
  options: ["30", "28", "32", "26"],
  answer: "30"
},
{
  question: "What is the value of (5^2 - 3^2)?",
  options: ["16", "25", "9", "8"],
  answer: "16"
},
{
  question: "A triangle has angles 2x, 3x, and x. Find x.",
  options: ["30 degrees", "45 degrees", "60 degrees", "20 degrees"],
  answer: "30 degrees"
},
{
  question: "What is the volume of a cylinder with radius 3 cm and height 7 cm? (pi = 22/7)",
  options: ["198 cm^3", "66 cm^3", "154 cm^3", "132 cm^3"],
  answer: "198 cm^3"
},
{
  question: "If a = 2 and b = 3, find the value of 2a^2 + 3b.",
  options: ["17", "13", "11", "19"],
  answer: "17"
},

{
  question: "A die is rolled once. What is the probability of getting a number greater than 4?",
  options: ["1/6", "2/6", "3/6", "4/6"],
  answer: "2/6"
},
{
  question: "A card is picked from a standard deck. What is the probability of picking a king?",
  options: ["1/13", "4/52", "1/4", "1/52"],
  answer: "1/13"
},
{
  question: "A bag contains 4 red, 3 blue, and 3 yellow balls. What is the probability of picking a red ball?",
  options: ["4/10", "3/10", "1/2", "2/5"],
  answer: "4/10"
},
{
  question: "Two coins are tossed. What is the probability of getting two heads?",
  options: ["1/2", "1/4", "2/4", "3/4"],
  answer: "1/4"
},
{
  question: "Which of the following represents the universal set?",
  options: ["U", "A", "B", "?" ],
  answer: "U"
},
{
  question: "If A = {1,2,3} and B = {3,4,5}, what is A ∩ B?",
  options: ["{3}", "{1,2}", "{4,5}", "{1,2,3,4,5}"],
  answer: "{3}"
},
{
  question: "If A = {1,2,3} and B = {3,4,5}, what is A ∪ B?",
  options: ["{1,2,3,4,5}", "{3}", "{1,2}", "{4,5}"],
  answer: "{1,2,3,4,5}"
},
{
  question: "If U = {1,2,3,4,5} and A = {1,2}, what is A'?",
  options: ["{3,4,5}", "{1,2}", "{1,2,3}", "{4,5}"],
  answer: "{3,4,5}"
},
{
  question: "How many elements are in the set {2,4,6,8,10}?",
  options: ["4", "5", "6", "3"],
  answer: "5"
},
{
  question: "What is the complement of set B if U = {1,2,3,4,5} and B = {2,3}?",
  options: ["{1,4,5}", "{2,3}", "{1,2,3}", "{4,5}"],
  answer: "{1,4,5}"
},
{
  question: "If 20 students like Maths, 15 like English, and 5 like both, how many like only Maths?",
  options: ["15", "20", "10", "5"],
  answer: "15"
},
{
  question: "If 50 students were surveyed and 10 like neither subject, how many like at least one subject?",
  options: ["40", "30", "50", "10"],
  answer: "40"
},
{
  question: "What is the gradient of a straight line that rises 4 units for every 2 units across?",
  options: ["2", "1/2", "4", "6"],
  answer: "2"
},
{
  question: "Find the gradient between points (2,3) and (4,7).",
  options: ["2", "3", "4", "1"],
  answer: "2"
},
{
  question: "What is the y-intercept of the line y = 2x + 3?",
  options: ["2", "3", "5", "1"],
  answer: "3"
},
{
  question: "Which of the following represents a straight-line graph?",
  options: ["y = 2x + 1", "y = x^2", "y = 1/x", "y = ax"],
  answer: "y = 2x + 1"
},
{
  question: "If a graph passes through the origin, what is its y-intercept?",
  options: ["1", "0", "2", "-1"],
  answer: "0"
},
{
  question: "What is the value of y when x = 2 in the equation y = 3x + 1?",
  options: ["7", "5", "6", "8"],
  answer: "7"
},
{
  question: "Which of the following is a correct probability value?",
  options: ["1.5", "-0.2", "0.8", "2"],
  answer: "0.8"
},
{
  question: "If the probability of an event happening is 0, what does it mean?",
  options: ["Certain", "Impossible", "Likely", "Uncertain"],
  answer: "Impossible"
},
{
  question: "A trader bought a bag for GHc80 and sold it for GHc100. What was the profit percentage?",
  options: ["20%", "25%", "30%", "15%"],
  answer: "25%"
},
{
  question: "A car travels 120 km in 2 hours. What is its average speed?",
  options: ["60 km/h", "50 km/h", "40 km/h", "80 km/h"],
  answer: "60 km/h"
},
{
  question: "A man saves GHc50 every week. How much will he save in 8 weeks?",
  options: ["GHc400", "GHc300", "GHc450", "GHc350"],
  answer: "GHc400"
},
{
  question: "If 5 pens cost GHc10, how much will 8 pens cost?",
  options: ["GHc16", "GHc15", "GHc20", "GHc18"],
  answer: "GHc16"
},
{
  question: "A rectangular field is 20 m long and 15 m wide. What is its area?",
  options: ["300 m^2", "350 m^2", "200 m^2", "250 m^2"],
  answer: "300 m^2"
},
{
  question: "A student scored 45, 55, and 60 in three tests. What is the average score?",
  options: ["53.3", "50", "55", "52"],
  answer: "53.3"
},
{
  question: "A number is divided by 4 and gives 6. What is the number?",
  options: ["24", "20", "18", "22"],
  answer: "24"
},
{
  question: "If 3x = 21, what is the value of x?",
  options: ["7", "6", "8", "5"],
  answer: "7"
},
{
  question: "A shopkeeper gives a discount of GHc10 on an item originally costing GHc60. What is the new price?",
  options: ["GHc50", "GHc40", "GHc45", "GHc55"],
  answer: "GHc50"
},
{
  question: "A train travels 180 km in 3 hours. What is its speed?",
  options: ["60 km/h", "70 km/h", "50 km/h", "80 km/h"],
  answer: "60 km/h"
},
{
  question: "A class has 20 boys and 30 girls. What fraction of the class are boys?",
  options: ["2/5", "1/2", "3/5", "1/3"],
  answer: "2/5"
},
{
  question: "If a book costs GHc12, how many can be bought with GHc60?",
  options: ["5", "6", "4", "7"],
  answer: "5"
},
{
  question: "A farmer has 24 goats. He sells 1/3 of them. How many goats remain?",
  options: ["16", "12", "18", "20"],
  answer: "16"
},
{
  question: "The perimeter of a square is 40 cm. What is the length of one side?",
  options: ["10 cm", "20 cm", "5 cm", "8 cm"],
  answer: "10 cm"
},
{
  question: "A number is increased by 10 to become 35. What is the number?",
  options: ["25", "20", "30", "15"],
  answer: "25"
},
{
  question: "A man shares GHc120 equally among 6 children. How much does each get?",
  options: ["GHc20", "GHc25", "GHc15", "GHc30"],
  answer: "GHc20"
},
{
  question: "If 2x + 5 = 15, find x.",
  options: ["5", "4", "6", "3"],
  answer: "5"
},
{
  question: "A rectangle has a perimeter of 30 cm. If the length is 10 cm, find the width.",
  options: ["5 cm", "10 cm", "8 cm", "6 cm"],
  answer: "5 cm"
},
{
  question: "A student scored 80% in a test of 50 marks. How many marks did the student get?",
  options: ["40", "35", "45", "30"],
  answer: "40"
},
{
  question: "A tank holds 200 litres of water. If 50 litres are used, how much remains?",
  options: ["150 litres", "100 litres", "120 litres", "140 litres"],
  answer: "150 litres"
},

{
  question: "Simplify: 2(x + 3) - 3(x - 2)",
  options: ["12 - x", "x + 12", "5x + 6", "x - 12"],
  answer: "12 - x"
},
{
  question: "Solve: 2x + 3 = x + 9",
  options: ["6", "5", "4", "3"],
  answer: "6"
},
{
  question: "Find the value of x: 3(x - 2) = 2(x + 4)",
  options: ["14", "10", "12", "8"],
  answer: "14"
},
{
  question: "If 2 : 3 = x : 12, find x.",
  options: ["8", "6", "10", "9"],
  answer: "8"
},
{
  question: "A number is increased by 20% and becomes 72. Find the original number.",
  options: ["60", "50", "55", "65"],
  answer: "60"
},
{
  question: "The angles of a triangle are in the ratio 2 : 3 : 4. Find the largest angle.",
  options: ["80 degrees", "60 degrees", "100 degrees", "120 degrees"],
  answer: "80 degrees"
},
{
  question: "A man buys an item for GHc200 and sells it at a loss of 10%. What is the selling price?",
  options: ["GHc180", "GHc190", "GHc170", "GHc160"],
  answer: "GHc180"
},
{
  question: "Find the simple interest on GHc500 at 10% per annum for 2 years.",
  options: ["GHc100", "GHc50", "GHc150", "GHc200"],
  answer: "GHc100"
},
{
  question: "What is the area of a triangle with base 10 cm and height 6 cm?",
  options: ["30 cm^2", "60 cm^2", "16 cm^2", "36 cm^2"],
  answer: "30 cm^2"
},
{
  question: "If y = 3x + 2, find y when x = 4.",
  options: ["14", "12", "16", "10"],
  answer: "14"
},
{
  question: "A bag contains 6 red and 4 blue balls. Two balls are picked at random. What is the probability both are red?",
  options: ["1/3", "1/5", "2/5", "3/10"],
  answer: "1/3"
},
{
  question: "Find the mean of: 2, 4, 6, 8, 10.",
  options: ["6", "5", "7", "8"],
  answer: "6"
},
{
  question: "Solve: x^2 = 49",
  options: ["7 or -7", "7", "-7", "49"],
  answer: "7 or -7"
},
{
  question: "Convert 0.375 to a fraction in its simplest form.",
  options: ["3/8", "5/8", "7/8", "1/8"],
  answer: "3/8"
},
{
  question: "Find the perimeter of a rectangle with length 12 cm and width 8 cm.",
  options: ["40 cm", "20 cm", "96 cm", "30 cm"],
  answer: "40 cm"
},
{
  question: "If a number is multiplied by 4 and 6 is added, the result is 26. Find the number.",
  options: ["5", "6", "4", "3"],
  answer: "5"
},
{
  question: "A student scored 72 out of 80. What is the percentage score?",
  options: ["90%", "85%", "80%", "95%"],
  answer: "90%"
},
{
  question: "Find the value of: 5^3 ÷ 5^2",
  options: ["5", "25", "125", "1"],
  answer: "5"
},
{
  question: "If the radius of a circle is doubled, what happens to the area?",
  options: [
    "It doubles",
    "It becomes four times",
    "It halves",
    "It remains the same"
  ],
  answer: "It becomes four times"
},
{
  question: "A sum of money doubles in 5 years at simple interest. What is the rate per annum?",
  options: ["20%", "10%", "15%", "25%"],
  answer: "20%"
},
{
  question: "Simplify: (3/4) x (2/5)",
  options: ["15/8", "8/15", "6/20", "3/10"],
  answer: "3/10"
},
{
  question: "Evaluate: 2^3 + 3^2 x 2",
  options: ["22", "26", "18", "20"],
  answer: "26"
},
{
  question: "Solve: 5x - 7 = 3x + 9",
  options: ["8", "6", "7", "9"],
  answer: "8"
},
{
  question: "If 12 men can complete a work in 10 days, how many days will 6 men take?",
  options: ["20", "15", "10", "5"],
  answer: "20"
},
{
  question: "Find the median of: 5, 7, 9, 11, 13",
  options: ["9", "8", "7", "11"],
  answer: "9"
},
{
  question: "What is the LCM of 8 and 12?",
  options: ["24", "48", "16", "32"],
  answer: "24"
},
{
  question: "A trader gains 20% on an item sold for GHc120. Find the cost price.",
  options: ["GHc100", "GHc90", "GHc80", "GHc110"],
  answer: "GHc100"
},
{
  question: "Convert 3/5 to a percentage.",
  options: ["60%", "50%", "70%", "40%"],
  answer: "60%"
},
{
  question: "Find the value of: 9x - 4 when x = 3.",
  options: ["23", "27", "20", "25"],
  answer: "23"
},
{
  question: "If a triangle has sides 3 cm, 4 cm, and 5 cm, what type of triangle is it?",
  options: ["Right-angled", "Equilateral", "Isosceles", "Scalene"],
  answer: "Right-angled"
},
{
  question: "Simplify: 4x^2 ÷ 2x",
  options: ["2x", "2x^2", "x^2", "4x"],
  answer: "2x"
},
{
  question: "Find the simple interest on GHc800 at 5% for 3 years.",
  options: ["GHc120", "GHc100", "GHc150", "GHc80"],
  answer: "GHc120"
},
{
  question: "If the perimeter of a square is 64 cm, find its area.",
  options: ["256 cm^2", "64 cm^2", "128 cm^2", "32 cm^2"],
  answer: "256 cm^2"
},
{
  question: "Solve: 2(x + 5) = 3(x - 1)",
  options: ["13", "10", "8", "7"],
  answer: "13"
},
{
  question: "Find the value of: 6^2 - 2^2",
  options: ["28", "32", "30", "26"],
  answer: "32"
},
{
  question: "If 40% of a number is 20, find the number.",
  options: ["50", "40", "60", "45"],
  answer: "50"
},
{
  question: "A car covers 150 km using 10 litres of fuel. How many km per litre?",
  options: ["15", "10", "12", "20"],
  answer: "15"
},
{
  question: "Find the probability of getting a tail when a coin is tossed.",
  options: ["1/2", "1/4", "2/3", "1"],
  answer: "1/2"
},
{
  question: "If x + y = 10 and x = 4, find y.",
  options: ["6", "5", "4", "7"],
  answer: "6"
},
{
  question: "A shopkeeper gives 10% discount on GHc200. What is the discount amount?",
  options: ["GHc20", "GHc10", "GHc30", "GHc25"],
  answer: "GHc20"
},

{
  question: "Simplify: 4x + 3x",
  options: ["7x", "12x", "x^2", "4x^2"],
  answer: "7x"
},
{
  question: "Simplify: 5a - 2a",
  options: ["3a", "7a", "10a", "5a^2"],
  answer: "3a"
},
{
  question: "Simplify: 3x + 2y + x",
  options: ["4x + 2y", "5xy", "3x + 3y", "2x + y"],
  answer: "4x + 2y"
},
{
  question: "Expand: 2(x + 5)",
  options: ["2x + 10", "2x + 5", "x + 10", "2x^2 + 5"],
  answer: "2x + 10"
},
{
  question: "Expand: 3(a - 4)",
  options: ["3a - 12", "3a - 4", "a - 12", "3a + 4"],
  answer: "3a - 12"
},
{
  question: "Solve: x + 9 = 15",
  options: ["6", "5", "4", "7"],
  answer: "6"
},
{
  question: "Solve: 2x = 14",
  options: ["7", "6", "8", "5"],
  answer: "7"
},
{
  question: "Solve: x - 5 = 12",
  options: ["17", "7", "12", "15"],
  answer: "17"
},
{
  question: "Solve: 3x + 4 = 19",
  options: ["5", "6", "7", "4"],
  answer: "5"
},
{
  question: "Solve: 2x + 3 = 11",
  options: ["4", "3", "5", "6"],
  answer: "4"
},
{
  question: "Solve: 5x - 2 = 18",
  options: ["4", "3", "5", "6"],
  answer: "4"
},
{
  question: "Solve: 4x + 1 = 17",
  options: ["4", "3", "5", "6"],
  answer: "4"
},
{
  question: "If x = 3, find 2x + 5.",
  options: ["11", "10", "9", "12"],
  answer: "11"
},
{
  question: "If y = 2, find 3y^2.",
  options: ["12", "6", "8", "10"],
  answer: "12"
},
{
  question: "Simplify: 2x x 3x",
  options: ["6x^2", "5x^2", "6x", "3x^2"],
  answer: "6x^2"
},
{
  question: "Simplify: 4a x 2a",
  options: ["8a^2", "6a^2", "8a", "2a^2"],
  answer: "8a^2"
},
{
  question: "Solve: 6x = 30",
  options: ["5", "6", "4", "3"],
  answer: "5"
},
{
  question: "Solve: x/3 = 4",
  options: ["12", "7", "9", "6"],
  answer: "12"
},
{
  question: "Solve: x/5 = 6",
  options: ["30", "25", "35", "20"],
  answer: "30"
},
{
  question: "Which of the following is an inequality?",
  options: ["x + 3 > 5", "x + 3 = 5", "x + 3 x 5", "x + 3"],
  answer: "x + 3 > 5"
},
{
  question: "What is the sum of angles in a triangle?",
  options: ["180 degrees", "360 degrees", "90 degrees", "270 degrees"],
  answer: "180 degrees"
},
{
  question: "Find x: angles of a triangle are 50 degrees, 60 degrees, and x.",
  options: ["70 degrees", "80 degrees", "60 degrees", "90 degrees"],
  answer: "70 degrees"
},
{
  question: "What is the sum of angles around a point?",
  options: ["360 degrees", "180 degrees", "90 degrees", "270 degrees"],
  answer: "360 degrees"
},
{
  question: "Find x: angles on a straight line are 120 degrees and x.",
  options: ["60 degrees", "70 degrees", "50 degrees", "80 degrees"],
  answer: "60 degrees"
},
{
  question: "What is the sum of interior angles of a quadrilateral?",
  options: ["360 degrees", "180 degrees", "540 degrees", "720 degrees"],
  answer: "360 degrees"
},
{
  question: "Find x: a quadrilateral has angles 90 degrees, 80 degrees, 100 degrees, and x.",
  options: ["90 degrees", "80 degrees", "70 degrees", "60 degrees"],
  answer: "90 degrees"
},
{
  question: "What is the sum of interior angles of a pentagon?",
  options: ["540 degrees", "360 degrees", "720 degrees", "180 degrees"],
  answer: "540 degrees"
},
{
  question: "Find the exterior angle of a regular hexagon.",
  options: ["60 degrees", "90 degrees", "45 degrees", "120 degrees"],
  answer: "60 degrees"
},
{
  question: "If two angles are complementary, their sum is:",
  options: ["90 degrees", "180 degrees", "360 degrees", "270 degrees"],
  answer: "90 degrees"
},
{
  question: "If two angles are supplementary, their sum is:",
  options: ["180 degrees", "90 degrees", "360 degrees", "270 degrees"],
  answer: "180 degrees"
},
{
  question: "What is the size of each angle in an equilateral triangle?",
  options: ["60 degrees", "90 degrees", "120 degrees", "45 degrees"],
  answer: "60 degrees"
},
{
  question: "What is the size of each angle in a square?",
  options: ["90 degrees", "60 degrees", "120 degrees", "45 degrees"],
  answer: "90 degrees"
},
{
  question: "Parallel lines are cut by a transversal. Corresponding angles are:",
  options: ["Equal", "Supplementary", "Complementary", "Different"],
  answer: "Equal"
},
{
  question: "Alternate angles in parallel lines are:",
  options: ["Equal", "Supplementary", "Complementary", "Zero"],
  answer: "Equal"
},
{
  question: "Co-interior angles on parallel lines add up to:",
  options: ["180 degrees", "90 degrees", "360 degrees", "270 degrees"],
  answer: "180 degrees"
},
{
  question: "A right angle is:",
  options: ["90 degrees", "180 degrees", "45 degrees", "60 degrees"],
  answer: "90 degrees"
},
{
  question: "An acute angle is:",
  options: [
    "Less than 90 degrees",
    "Greater than 90 degrees",
    "Equal to 90 degrees",
    "Equal to 180 degrees"
  ],
  answer: "Less than 90 degrees"
},
{
  question: "An obtuse angle is:",
  options: [
    "Greater than 90 degrees but less than 180 degrees",
    "Less than 90 degrees",
    "Equal to 90 degrees",
    "Greater than 180 degrees"
  ],
  answer: "Greater than 90 degrees but less than 180 degrees"
},
{
  question: "How many sides does a hexagon have?",
  options: ["6", "5", "7", "8"],
  answer: "6"
},
{
  question: "How many sides does a pentagon have?",
  options: ["5", "6", "4", "7"],
  answer: "5"
},

{
  question: "Find the area of a rectangle of length 12 cm and width 7 cm.",
  options: ["84 cm^2", "38 cm^2", "96 cm^2", "72 cm^2"],
  answer: "84 cm^2"
},
{
  question: "The perimeter of a rectangle is 50 cm. If the length is 15 cm, find the width.",
  options: ["10 cm", "20 cm", "15 cm", "12 cm"],
  answer: "10 cm"
},
{
  question: "Find the area of a triangle with base 10 cm and height 8 cm.",
  options: ["40 cm^2", "80 cm^2", "18 cm^2", "20 cm^2"],
  answer: "40 cm^2"
},
{
  question: "Find the area of a circle of radius 7 cm (pi = 22/7).",
  options: ["154 cm^2", "49 cm^2", "44 cm^2", "100 cm^2"],
  answer: "154 cm^2"
},
{
  question: "Find the circumference of a circle of radius 7 cm (pi = 22/7).",
  options: ["44 cm", "154 cm", "22 cm", "88 cm"],
  answer: "44 cm"
},
{
  question: "A square has area 121 cm^2. Find its perimeter.",
  options: ["44 cm", "22 cm", "11 cm", "33 cm"],
  answer: "44 cm"
},
{
  question: "Find the volume of a cube of side 5 cm.",
  options: ["125 cm^3", "25 cm^3", "100 cm^3", "150 cm^3"],
  answer: "125 cm^3"
},
{
  question: "Find the volume of a cuboid with length 10 cm, width 4 cm, and height 3 cm.",
  options: ["120 cm^3", "60 cm^3", "100 cm^3", "140 cm^3"],
  answer: "120 cm^3"
},
{
  question: "Find the area of a trapezium with parallel sides 8 cm and 12 cm and height 5 cm.",
  options: ["50 cm^2", "100 cm^2", "40 cm^2", "60 cm^2"],
  answer: "50 cm^2"
},
{
  question: "Find the area of a parallelogram with base 9 cm and height 6 cm.",
  options: ["54 cm^2", "27 cm^2", "45 cm^2", "36 cm^2"],
  answer: "54 cm^2"
},
{
  question: "A cylindrical tank has radius 3 cm and height 10 cm. Find its volume (pi = 22/7).",
  options: ["283 cm^3", "200 cm^3", "150 cm^3", "300 cm^3"],
  answer: "283 cm^3"
},
{
  question: "A field is 20 m long and 15 m wide. Find the cost of fencing it at GHc5 per metre.",
  options: ["GHc350", "GHc300", "GHc250", "GHc400"],
  answer: "GHc350"
},
{
  question: "A rectangular plot has area 200 m^2 and length 20 m. Find the width.",
  options: ["10 m", "5 m", "20 m", "15 m"],
  answer: "10 m"
},
{
  question: "The diameter of a circle is 14 cm. Find its radius.",
  options: ["7 cm", "14 cm", "21 cm", "28 cm"],
  answer: "7 cm"
},
{
  question: "Find the perimeter of a semicircle of radius 7 cm (pi = 22/7).",
  options: ["36 cm", "44 cm", "22 cm", "30 cm"],
  answer: "36 cm"
},
{
  question: "A cube has volume 64 cm^3. Find the length of its side.",
  options: ["4 cm", "8 cm", "16 cm", "2 cm"],
  answer: "4 cm"
},
{
  question: "Find the surface area of a cube of side 3 cm.",
  options: ["54 cm^2", "27 cm^2", "36 cm^2", "18 cm^2"],
  answer: "54 cm^2"
},
{
  question: "Find the area of a sector of a circle of radius 7 cm with angle 90 degrees (pi = 22/7).",
  options: ["38.5 cm^2", "49 cm^2", "77 cm^2", "25 cm^2"],
  answer: "38.5 cm^2"
},
{
  question: "A rectangular tank measures 5 m x 4 m x 2 m. Find its volume.",
  options: ["40 m^3", "20 m^3", "50 m^3", "60 m^3"],
  answer: "40 m^3"
},
{
  question: "A wire of length 44 cm is bent into a circle. Find the radius (pi = 22/7).",
  options: ["7 cm", "14 cm", "3.5 cm", "10 cm"],
  answer: "7 cm"
},
{
  question: "If A = {1,2,3} and B = {3,4,5}, find A ∩ B.",
  options: ["{3}", "{1,2}", "{4,5}", "{1,2,3,4,5}"],
  answer: "{3}"
},
{
  question: "If A = {1,2,3} and B = {3,4,5}, find A ∪ B.",
  options: ["{1,2,3,4,5}", "{3}", "{1,2}", "{4,5}"],
  answer: "{1,2,3,4,5}"
},
{
  question: "If U = {1,2,3,4,5} and A = {2,3}, find A'.",
  options: ["{1,4,5}", "{2,3}", "{1,2,3}", "{4,5}"],
  answer: "{1,4,5}"
},
{
  question: "How many elements are in the set {2,4,6,8,10}?",
  options: ["5", "4", "6", "3"],
  answer: "5"
},
{
  question: "In a class of 30 students, 18 like Maths, 12 like English, and 5 like both. How many like only Maths?",
  options: ["13", "18", "5", "12"],
  answer: "13"
},
{
  question: "How many students like only English?",
  options: ["7", "12", "5", "10"],
  answer: "7"
},
{
  question: "How many students like at least one subject?",
  options: ["25", "30", "20", "18"],
  answer: "25"
},
{
  question: "How many students like neither subject?",
  options: ["5", "3", "2", "4"],
  answer: "5"
},
{
  question: "A trader buys an item for GHc120 and sells it for GHc150. Find the profit.",
  options: ["GHc30", "GHc20", "GHc40", "GHc50"],
  answer: "GHc30"
},
{
  question: "Find the profit percentage.",
  options: ["25%", "20%", "30%", "15%"],
  answer: "25%"
},
{
  question: "A car travels 180 km in 3 hours. What is its speed?",
  options: ["60 km/h", "50 km/h", "70 km/h", "80 km/h"],
  answer: "60 km/h"
},
{
  question: "If 4 pens cost GHc8, how much do 10 pens cost?",
  options: ["GHc20", "GHc18", "GHc16", "GHc25"],
  answer: "GHc20"
},
{
  question: "A man saves GHc25 weekly. How much will he save in 12 weeks?",
  options: ["GHc300", "GHc250", "GHc275", "GHc350"],
  answer: "GHc300"
},
{
  question: "A number is increased by 20 to become 75. Find the number.",
  options: ["55", "50", "45", "60"],
  answer: "55"
},
{
  question: "If 3x = 24, find x.",
  options: ["8", "6", "7", "9"],
  answer: "8"
},
{
  question: "A rectangular field is 25 m long and 10 m wide. Find its perimeter.",
  options: ["70 m", "60 m", "50 m", "80 m"],
  answer: "70 m"
},
{
  question: "A student scored 45 out of 60. Find the percentage.",
  options: ["75%", "70%", "80%", "65%"],
  answer: "75%"
},

{
  question: "Simplify: (3/5) + (7/10)",
  options: ["13/10", "10/15", "1", "11/10"],
  answer: "13/10"
},
{
  question: "Evaluate: 2^4 + 3^2",
  options: ["31", "25", "17", "35"],
  answer: "25"
},
{
  question: "Solve: 4x - 3 = 13",
  options: ["4", "5", "3", "6"],
  answer: "4"
},
{
  question: "A number is reduced by 20% to become 80. Find the original number.",
  options: ["100", "90", "80", "120"],
  answer: "100"
},
{
  question: "Find the HCF of 18, 24, and 30.",
  options: ["6", "3", "12", "9"],
  answer: "6"
},
{
  question: "Find the LCM of 6, 8, and 12.",
  options: ["24", "48", "12", "36"],
  answer: "24"
},
{
  question: "If 5x = 45, find x.",
  options: ["9", "8", "7", "6"],
  answer: "9"
},
{
  question: "A triangle has angles 3x, 4x, and 5x. Find x.",
  options: ["15 degrees", "12 degrees", "10 degrees", "9 degrees"],
  answer: "15 degrees"
},
{
  question: "Find the area of a circle of diameter 14 cm (pi = 22/7).",
  options: ["154 cm^2", "44 cm^2", "49 cm^2", "100 cm^2"],
  answer: "154 cm^2"
},
{
  question: "A trader buys an item for GHc150 and sells it for GHc180. Find the profit percentage.",
  options: ["20%", "15%", "25%", "30%"],
  answer: "20%"
},
{
  question: "Find the mean of: 5, 10, 15, 20, 25.",
  options: ["15", "10", "20", "12"],
  answer: "15"
},
{
  question: "What is the probability of getting a number less than 5 on a die?",
  options: ["4/6", "3/6", "5/6", "2/6"],
  answer: "4/6"
},
{
  question: "Find the gradient between (2,3) and (5,9).",
  options: ["2", "3", "1", "4"],
  answer: "2"
},
{
  question: "If y = 3x + 2 and x = 4, find y.",
  options: ["14", "12", "16", "10"],
  answer: "14"
},
{
  question: "Solve: 2(x + 3) = 10",
  options: ["2", "3", "4", "5"],
  answer: "2"
},
{
  question: "Convert 0.2 to a fraction in simplest form.",
  options: ["1/5", "2/5", "1/2", "2/10"],
  answer: "1/5"
},
{
  question: "A cube has side 6 cm. Find its volume.",
  options: ["216 cm^3", "36 cm^3", "180 cm^3", "200 cm^3"],
  answer: "216 cm^3"
},
{
  question: "If P(A) = 0.6, find P(not A).",
  options: ["0.4", "0.6", "1.6", "0.5"],
  answer: "0.4"
},
{
  question: "Simplify: 3x^2 ÷ 2x",
  options: ["6x", "5x", "3/2 x", "3x"],
  answer: "3/2 x"
},
{
  question: "Find the value of x: x/4 = 5.",
  options: ["20", "10", "15", "25"],
  answer: "20"
},
{
  question: "A bearing of a point from North is measured clockwise. What is the bearing of East?",
  options: ["090 degrees", "180 degrees", "270 degrees", "360 degrees"],
  answer: "090 degrees"
},
{
  question: "What is the bearing of South-West?",
  options: ["225 degrees", "135 degrees", "315 degrees", "180 degrees"],
  answer: "225 degrees"
},
{
  question: "A point is directly South of another. What is its bearing?",
  options: ["180 degrees", "090 degrees", "270 degrees", "360 degrees"],
  answer: "180 degrees"
},
{
  question: "Solve the inequality: x + 5 > 9",
  options: ["x > 4", "x < 4", "x = 4", "x != 4"],
  answer: "x > 4"
},
{
  question: "Solve: 2x - 3 > 7",
  options: ["x > 5", "x < 5", "x = 5", "x != 5"],
  answer: "x > 5"
},
{
  question: "Which value satisfies the inequality x > 6?",
  options: ["7", "6", "5", "4"],
  answer: "7"
},
{
  question: "A graph shows a straight line passing through (0,2). What is the y-intercept?",
  options: ["2", "0", "1", "-2"],
  answer: "2"
},
{
  question: "If a graph slopes downward from left to right, the gradient is:",
  options: ["Negative", "Positive", "Zero", "Undefined"],
  answer: "Negative"
},

{
  question: "The diagram shows triangle ABC with angles 60 degrees, 50 degrees and x at C. Find x.",
  image: "/images/math1.png",
  options: ["60 degrees", "70 degrees", "80 degrees", "90 degrees"],
  answer: "70 degrees"
},
{
  question: "The diagram shows a rectangle of length 8 cm and width 5 cm. Find the perimeter.",
  image: "/images/math2.png",
  options: ["13 cm", "26 cm", "40 cm", "16 cm"],
  answer: "26 cm"
},
{
  question: "The diagram shows a number line with point X at -2. What is the value of X?",
  image: "/images/math3.png",
  options: ["-2", "2", "-1", "0"],
  answer: "-2"
},
{
  question: "Two parallel lines are cut by a transversal. One angle is 70 degrees. Find x.",
  image: "/images/math4.png",
  options: ["70 degrees", "110 degrees", "90 degrees", "50 degrees"],
  answer: "70 degrees"
},
{
  question: "The diagram shows a triangle with an exterior angle of 130 degrees and one interior angle of 60 degrees. Find x.",
  image: "/images/math5.png",
  options: ["50 degrees", "60 degrees", "70 degrees", "80 degrees"],
  answer: "70 degrees"
},
{
  question: "The diagram shows a circle with radius 7 cm. Find the circumference (pi = 22/7).",
  image: "/images/math6.png",
  options: ["44 cm", "22 cm", "154 cm", "88 cm"],
  answer: "44 cm"
},
{
  question: "The diagram shows sets A and B. Find the number of elements in A ∩ B.",
  image: "/images/math7.png",
  options: ["1", "2", "3", "4"],
  answer: "2"
},
{
  question: "The diagram shows a bearing of 045 degrees from North. What direction is this?",
  image: "/images/math8.png",
  options: ["NE", "NW", "SE", "SW"],
  answer: "NE"
},
{
  question: "Point (3,4) is reflected in the x-axis. Find the new coordinates.",
  image: "/images/math9.png",
  options: ["(3,-4)", "(-3,4)", "(-3,-4)", "(4,3)"],
  answer: "(3,-4)"
},
{
  question: "The diagram shows a triangle with base 10 cm and height 6 cm. Find the area.",
  image: "/images/math10.png",
  options: ["30 cm^2", "60 cm^2", "16 cm^2", "20 cm^2"],
  answer: "30 cm^2"
},

{
  question: "The diagram shows a point P moving such that it is always equidistant from two points A and B. What is the locus of P?",
  image: "/images/math31.png",
  options: ["Circle", "Perpendicular bisector", "Straight line", "Triangle"],
  answer: "Perpendicular bisector"
},
{
  question: "The diagram shows a point moving at a constant distance from a fixed point O. What is the locus?",
  image: "/images/math32.png",
  options: ["Circle", "Line", "Arc", "Triangle"],
  answer: "Circle"
},
{
  question: "The diagram shows a triangle with angles 2x, 3x and 4x. Find x.",
  image: "/images/math33.png",
  options: ["20 degrees", "15 degrees", "10 degrees", "30 degrees"],
  answer: "20 degrees"
},
{
  question: "The diagram shows two parallel lines cut by a transversal. One interior angle is 75 degrees. Find x (co-interior angle).",
  image: "/images/math34.png",
  options: ["105 degrees", "75 degrees", "95 degrees", "115 degrees"],
  answer: "105 degrees"
},
{
  question: "The diagram shows a cyclic quadrilateral with angles (x + 20) degrees and 100 degrees. Find x.",
  image: "/images/math35.png",
  options: ["80 degrees", "60 degrees", "100 degrees", "40 degrees"],
  answer: "80 degrees"
},
{
  question: "The diagram shows a circle with a tangent touching at point A. The radius OA is drawn. What is the angle between the radius and tangent?",
  image: "/images/math36.png",
  options: ["90 degrees", "45 degrees", "60 degrees", "120 degrees"],
  answer: "90 degrees"
},
{
  question: "The diagram shows a straight line divided in the ratio 2:3. If total length is 25 cm, find the longer part.",
  image: "/images/math37.png",
  options: ["10 cm", "15 cm", "20 cm", "5 cm"],
  answer: "15 cm"
},
{
  question: "The diagram shows a triangle rotated 90 degrees clockwise about the origin. What happens to point (1,2)?",
  image: "/images/math38.png",
  options: ["(2,-1)", "(-2,1)", "(1,-2)", "(-1,2)"],
  answer: "(2,-1)"
},
{
  question: "The diagram shows a line segment AB. A point P moves such that PA + PB is constant. What shape is formed?",
  image: "/images/math39.png",
  options: ["Circle", "Ellipse", "Line", "Triangle"],
  answer: "Ellipse"
},
{
  question: "The diagram shows a triangle inside a rectangle. If the rectangle area is 48 cm^2 and triangle shares same base and height, find triangle area.",
  image: "/images/math40.png",
  options: ["24 cm^2", "48 cm^2", "12 cm^2", "36 cm^2"],
  answer: "24 cm^2"
}

];
export default jshmathsQuestions;
